<template>
  <div class="profet-ai-input">
    <div 
      :style="isWarning ? labelStyle: {}" 
      class="profet-ai-input__name"
    >
      {{ label }}
    </div>
    <div 
      v-if="imgSrc" 
      class="profet-ai-input__img" 
      :class="{ 'profet-ai-input__img--hover' : enableActionOnIcon}" 
      @click="handleIconClick()"
      >
      <img :src="imgSrc" alt="user" />
    </div>
    <input 
      :style="isWarning ? inputStyle: {}" 
      class="profet-ai-input__input" 
      :type="type" v-model="_value" 
      :autofocus="focus"  
      @keyup.enter="handleEnterEvent" 
    />
  </div>
</template>
<script>
export default {
  props: {
    isWarning: Boolean,
    type: {
      default: 'text',
       validator: function (value) {
        return ['password', 'text'].indexOf(value) !== -1
      }
    }, // type
    label: String,
    value: [String],
    imgSrc: String,
    focus: Boolean,
    enableActionOnIcon: Boolean,
  }, //
  data() {
    return {
      labelStyle: {
        'color': 'red',
      }, // labelStyle
      inputStyle: {
        'border-color': 'red',
        'background-color': '#fffaff',
      }, // inputStyle
    };
  }, // End of data
  computed: {
    _value: {
      get() {
        return this.$props.value;
      }, // get
      set(val) {
        this.$emit("input", val);
      }, // set
    }, // _value
  }, // computed
  methods: {
    handleEnterEvent() {
      this.$emit('enter');
    }, // handleEnterEvent()
    handleIconClick() {
      if(this.$props.enableActionOnIcon){
        this.$emit("actionOnIcon")
      }
    }, //handleIconClick
  }, // End of methods
}; // End of export
</script>
<style lang="scss" scoped>
.profet-ai-input {
  display: flex;
  position: relative;
  margin: 10px 0px;
  &__name {
    position: absolute;
    top: 8px;
    left: 15px;
    font-size: 0.8rem;
    font-weight: 500;
    color: #bcbcbc;
  } // name

  &__img {
    position: absolute;
    top: 20px;
    right: 20px;
    &--hover{
      cursor: pointer;
    }
  } // img

  &__input {
    font-size: 1.25rem;
    color: #979797;
    width: 100%;
    height: 40px;
    border: 0px;
    border-radius: 5px;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1);
    padding: 15px;
    padding-top: 20px;
    padding-bottom: 6px;
    padding-right: 30px;
    border: 1px solid #fff;

    &:focus {
      background-color: #eafaff;
      color: #0d32c8;
      border: 1px solid #67b3ff;
      outline: none;
    }
  } // input
} // profet-ai-input
</style>
